function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUapi(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M20.63 2.419a.193.193 0 00-.266 0l-1.776 1.777a4.65 4.65 0 00-2.616-.801c-1.196 0-2.39.455-3.303 1.368l-2.379 2.38a.188.188 0 000 .263l6.342 6.344a.183.183 0 00.133.054.197.197 0 00.133-.054l2.379-2.38a4.676 4.676 0 00.567-5.918l1.776-1.777a.19.19 0 000-.266l-.99-.99zm-7.485 10.504l-1.555 1.555-2.107-2.108 1.557-1.557a.187.187 0 000-.264l-.85-.85a.187.187 0 00-.264 0L8.37 11.256l-1.003-1.004a.183.183 0 00-.134-.053.197.197 0 00-.133.053l-2.376 2.38a4.675 4.675 0 00-.567 5.919L2.38 20.327a.188.188 0 000 .264l.99.99a.193.193 0 00.266 0l1.776-1.777a4.65 4.65 0 002.616.801c1.196 0 2.39-.455 3.303-1.368l2.379-2.38a.187.187 0 000-.263l-1.004-1.004 1.557-1.558a.187.187 0 000-.263l-.854-.846a.187.187 0 00-.264 0z"
  }));
}

SvgUapi.clsName = 'icon-www__uapi';
SvgUapi.remarkName = 'unknown';
export default SvgUapi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uapi.js
// module id = 2449
// module chunks = 17 18